import { Box, Heading } from "@stenajs-webui/core";
import type { FC } from "react";

export interface BookingDetailsSectionHeaderProps {
  title: string;
}
export const BookingDetailsSectionHeader: FC<
  BookingDetailsSectionHeaderProps
> = ({ title }) => (
  <Box>
    <Heading variant={"h3"}>{title}</Heading>
  </Box>
);
